import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

import { useSlug } from 'src/utils';

const query = graphql`
  query GetTutorsCategoryMenus {
    japanese: allContentfulTutorsCategory(
      sort: { date: ASC }
      filter: { node_locale: { eq: "ja" } }
    ) {
      nodes {
        title
        slug
        contentful_id
        tutors {
          id
        }
      }
    }
    english: allContentfulTutorsCategory(
      sort: { date: ASC }
      filter: { node_locale: { eq: "en" } }
    ) {
      nodes {
        title
        slug
        contentful_id
        tutors {
          id
        }
      }
    }
  }
`;

export const useTutorsCategoryMenus = () => {
  const { japanese, english } =
    useStaticQuery<Queries.GetTutorsCategoryMenusQuery>(query);
  const { lang } = useSlug();
  return useMemo(() => {
    const list = lang === 'ja' ? japanese : english;
    return list.nodes
      .filter((item) => item.tutors && item.tutors.length > 0)
      .map((item) => ({
        id: item?.contentful_id,
        name: 'tutors',
        label: item?.title ?? 'no label',
        href: item?.slug ? `/tutors/category/${item.slug}/` : '/tutors/',
      }));
  }, [japanese, english, lang]);
};
